export default "__VITE_ASSET__BssTAb1a__"